module.exports = __webpack_public_path__ + "static/img/40-3.b4424a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/40-3.jpg
// module id = /ICY
// module chunks = 0